/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

import Button from '@cashew/button';
import ConfirmModal from '@cashew/confirm-modal';
import Loading from '@cashew/loading';

import './index.css';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const { api } = require('@cashew/utils');

const ns = 'risk';
type Status = 'warning' | 'error' | 'info' | 'success' | 'none';

export default ({ showConfirmModal, setOpenSettings, afterUpload }: any) => {
  const [showResult, setShowResult] = useState(false);
  const [resultStatus, setResultStatus] = useState<Status>('none');
  const [errorMerchantId, setErrorMerchantId] = useState<any>('');
  const [finalError, setFinalError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { token } = useSelector((state: any) => state.user);
  const { t } = useTranslation();

  const handleOnChange = (event: any) => {
    event.preventDefault();
    const file = event.target.files[0];
    const isValidFile = file.name.split('.').at(-1) === 'xlsx';
    if (!isValidFile) {
      setResultStatus('warning');
      setShowResult(true);
      setFinalError(false);
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    setLoading(true);
    api
      .post({
        endpoint: 'identity/risk-rules',
        params: formData,
        headers: {
          Authorization: token,
        },
      })
      .then((response: any) => {
        if (response?.data?.importFailedMerchantId?.length > 0) {
          setShowResult(true);
          const result = response?.data?.importFailedMerchantId
            .map((value: any) => value.toString())
            .join(', ');
          setResultStatus('error');
          setFinalError(false);
          setErrorMerchantId(result);
        } else {
          setErrorMerchantId('');
          setShowResult(true);
          setResultStatus('success');
          setFinalError(false);
        }

        if (afterUpload) {
          afterUpload();
        }
      })
      .catch(() => {
        setErrorMerchantId('');
        setResultStatus('warning');
        setFinalError(true);
        setShowResult(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <ConfirmModal
      isVisible={showConfirmModal}
      onClose={() => {
        setOpenSettings(false);
      }}
      showCloseButton={false}
      confirmTitle="Are you sure you want to upload new risk rules?"
      confirmDescription="This will override the previously uploaded risk rules."
      confirmButtons={
        <div className={`${ns}__buttons`}>
          {loading ? (
            <Loading visible />
          ) : (
            <>
              <Button
                extraClass={classNames(
                  'btn-black secondary',
                  `${ns}__cancelBtn`
                )}
                onClick={() => {
                  setOpenSettings(false);
                }}
              >
                Cancel
              </Button>
              <label
                htmlFor="file-loader-button"
                className={classNames(
                  'btn order-details__confirm',
                  `${ns}__uploadBtn`
                )}
              >
                Upload
              </label>
              <input
                id="file-loader-button"
                type="file"
                onChange={handleOnChange}
                className={`${ns}__uploadInput`}
              />
            </>
          )}
        </div>
      }
      resultTitle={t(`settings.finalTitle.${resultStatus}`)}
      resultDescription={
        errorMerchantId?.length > 0
          ? `${t('settings.finalSubTitle.MerchantIdError')}<br>${errorMerchantId}`
          : t(`settings.finalSubTitle.${finalError ? 'error' : resultStatus}`)
      }
      resultButtons={
        <div>
          <Button
            extraClass="blue"
            onClick={() => {
              setOpenSettings(false);
              setResultStatus('none');
              setShowResult(false);
            }}
          >
            Ok
          </Button>
        </div>
      }
      showResult={showResult}
      resultStatus={resultStatus}
    />
  );
};
